module.exports = __webpack_public_path__ + "assets/img/reservation.86f8afab.svg";